import Rest from 'services/data/rest';

class Billing extends Rest {
  static path = 'billing';
}

// Exports
export default Billing;



// WEBPACK FOOTER //
// ./app/services/data/billing.js